import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <footer class="footer">
            <div class="container">
              <div class="row">
                <div class="col-md-3 m-b-20">
                  <div class="footer-title m-t-5 m-b-30 p-b-8">About us</div>
                  <p class="white-text">
                  <span>
                  Here students of our college can get all the branch related books, technical equipments and other college exams related study material.
                  </span>
                  </p>
                </div>

                <div class="col-md-2 m-b-20">
                  <div class="footer-title m-t-5 m-b-30 p-b-8">
                  <a href="https://github.com/Satwikan/2nd-hand-mbm">
                  Satwik Anmol
                  </a>
                   

                  </div>
                  CSE undergrad | Web developer | CC
                  </div>

                  <div class="col-md-2 m-b-20">
                  <div class="footer-title m-t-5 m-b-30 p-b-8">
                  <a href ="https://github.com/Rajat-Jain29"> 
                  Rajat Jain
                  </a>
                   
                  </div>
                  Coding enthusiast | WEB developer | CC
                  </div>
                  <div class="col-md-2 m-b-20">
                  <div class="footer-title m-t-5 m-b-30 p-b-8">
                  <a href="https://github.com/tanmay12-sud0">
                  Tanmay Goyal
                  </a>
                 
                  </div>
               

                  Full Stack developer | React native Android developer | CC
                  </div>

                  <div class="col-md-3 m-b-30">
                  <div class="footer-title m-t-5 m-b-30 p-b-8">
                  <a href="https://github.com/RYzen-009">
                  Tanmay Mathur
                  </a>
                    
                  </div>
                  WEB developer | Open source contributor @ GSSOC'21 | CC
                  </div>

                 
                  {/* <div class="footer-links">
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">
                      Seller
                    </a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">Buyer</a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">
                      MBM Enginerring College
                    </a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">
                      Products
                    </a>
                  </div> */}
                {/* </div>
                <div class="col-md-3 m-b-30">
                  <div class="footer-title m-t-5 m-b-20 p-b-8">Quick Links</div>
                  <div class="footer-links">
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">Blog</a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">FAQ</a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">
                      Terms & conditions
                    </a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">
                      Privacy policy
                    </a>
                  </div>
                </div> */}
                {/* <div class="col-md-3 m-b-30">
                  <div class="footer-title m-t-5 m-b-20 p-b-8">Support</div>
                  <div class="footer-links">
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">
                      Affiliate
                    </a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">Login</a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">
                      All theme package
                    </a>
                    <a href="https://github.com/Satwikan/2nd-hand-mbm">
                      Support forum
                    </a>
                  </div>*/}
                </div> 
              </div>
            {/* </div> */}
          </footer>
          <div class="footer-bottom">Copyright © 2021, All Rights Reserved</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;